<div class="benefit-container">
  <div class="left" [ngClass]="{ 'display-none': !mira }">
    <div class="text-box">
      <span class="copec-lg-14" [ngClass]="{
          toback: !showHyperLink,
          tobackButton: showHyperLink,
          toback70: id === 70
        }"><a class="copec-lg-14 a-toback" routerLink="/welcome">Beneficios / </a>{{ this.category }}</span>
      <h2 class="copec-bold-30 titleBenefit" [ngClass]="{ titleBenefit70: id === 70 }">
        {{ this.title }}
      </h2>
      <p class="copec-rg-16-p descriptionBenefit">
        {{ this.longDescription }}
      </p>
      <button (click)="goToRedirect()" class="button-benefit" *ngIf="benefitIsPlan() && showHyperLink"
        [disabled]="vigencia"
        [ngClass]="{'button-disabled': vigencia}">
        <p style="color: white">
          {{ vigencia ? 'Beneficio sin Vigencia' : (isCopec ? 'Obtener Beneficio' : 'Conoce más') }}<img class="arrow" src="/assets/icono/icon-arrow.svg"
            alt="" *ngIf="!vigencia" />
        </p>
         <div  *ngIf="cargando_spinner" class="spinner" id="tab-hist-req32"></div>
      </button>
    </div>
  </div>
  <div class="rigth" [ngClass]="{ 'display-none': !mira }">
    <div class="">
      <img class="second-image" [ngClass]="{ imgCards: !benefitIsPlan() }" src="{{ this.image }}" alt="" />
    </div>
  </div>
</div>

<div class="benefit-container-fixed fixed" [ngClass]="{ 'display-none': mira }">
  <img class="third-image" [ngClass]="{ imgCards: !benefitIsPlan() }" src="{{ this.image }}" alt="" />
  <div class="text-box-fixed">
    <h2 class="copec-bold-30">{{ this.title }}</h2>
    <p class="copec-rg-16 text">
      {{ this.description }}
    </p>
  </div>
  <button (click)="goToRedirect()" class="button-benefit" *ngIf="benefitIsPlan() && showHyperLink"
    [disabled]="vigencia"
    [ngClass]="{'button-disabled': vigencia}">
    <p style="color: white">
      {{ vigencia ? 'Beneficio sin Vigencia' : (isCopec ? 'Obtener Beneficio' : 'Conoce más') }}<img class="arrow" src="/assets/icono/icon-arrow.svg" alt="" *ngIf="!vigencia" />
    </p>
  </button>
</div>

<div class="evaluate-container">
  <div class="row">
    <div class="col-sm-6 col-lg container-box">
      <div class="box">Categoría</div>
      <div class="icon">
        <img src="{{ this.icon }}" alt="" />
      </div>
      <span class="icon">{{ this.category }}</span>
    </div>
    <div class="col-sm-6 col-lg container-box card-white">
      <div class="box">Disponible desde</div>
      <div class="icon">
        <img src="/assets/icono-plans/{{ plan?.imageplan }}" alt="" />
      </div>
      <span class="icon">{{ plan?.titleplan }}</span>
    </div>
    <div class="col-sm-6 col-lg container-box">
      <div class="box">Antigüedad</div>
      <span class="icon copec-bold-20">{{ antiguedadRequerida()}}</span>
      <span class="icon">Mínimo</span>
    </div>
    <div class="col-sm-6 col-lg container-box card-white">
      <div class="box">Dirigido a</div>
      <span class="icon copec-bold-16">{{ this.beneficiaryType }}</span>
      <span class="icon">Multiuso</span>
    </div>
    <div class="col-6 col-lg container-box last-card">
      <div class="box">Valoración</div>
      <div class="icon">
        <i class="fa-solid fa-star"></i>
        <span><b>{{ averageUpdate() }}</b></span>
      </div>
      <span class="icon" *ngIf="datorating === 0">{{ totalVotes }} valoraciones</span>
      <span class="icon" *ngIf="datorating !== 0">{{ totalVotes + 1 }} valoraciones</span>
    </div>
  </div>
</div>

<!-- Modal de alerta para cuotas de préstamo -->
<div *ngIf="modalAlertaCuotas">
  <app-modal-alerta (closeModalAlerta)="closeModalAlertaCuotas($event)" [mensaje]="mensajeAlertaCuotas"
    [titulo]="tituloAlertaCuotas"></app-modal-alerta>
</div>

<!-- Modal de solicitudes en proceso -->
<div *ngIf="modalSolicitudesEnProceso" class="modalPlans">
  <div class="contenidoModal">
    <div class="header">
      <img src="/assets/icono-plans/alertamin.svg" alt="alerta">
      <img src="/assets/icono/equis.svg" class="cerrar mr-2" (click)="closeModalSolicitudesEnProceso()" alt="cerrar"/>
    </div>
    <div class="bajada">
      <h2 class="copec-bold-16">{{tituloSolicitudesEnProceso}}</h2>
      <p>{{mensajeSolicitudesEnProceso}}</p>
      <div class="solicitudes-ids-container">
        <span 
          *ngFor="let solicitud of solicitudesEnProcesoIds" 
          class="solicitud-id-chip"
          (click)="irADetalleSolicitud(solicitud.solicitud_id)"
          title="Click para ver detalles de la solicitud {{solicitud.solicitud_id}}">
          ID Solicitud: {{solicitud.solicitud_id}} - {{solicitud.beneficiarios.length > 1 ? 'Nombres Beneficiarios: ': 'Nombre Beneficiario: '}}{{solicitud.beneficiarios}}
        </span>
      </div>
    </div>
    <div class="botones-dobles">
      <button class="btn-secundario" (click)="irAMisSolicitudes()">Ir a Mis Solicitudes</button>
      <button class="btn-primario" (click)="continuarConFormulario()">Continuar</button>
    </div>
  </div>
</div>